// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__Wd5EE","productName":"Table_productName__hPUoi"};